import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import '@/utils/rem.js'

// 进度条
import "nprogress/nprogress.css";
// 自定义全局样式
import "@/assets/style/global/index.scss";

import Component from "vue-class-component";

// import VConsole from 'vconsole';
// const vConsole = new VConsole();

import {
    Button,
    Tabbar,
    TabbarItem,
    NavBar,
    Swipe,
    SwipeItem,
    SwipeCell,
    List,
    PullRefresh,
    CountDown,
    Form,
    Field,
    DropdownMenu,
    DropdownItem,
    Toast,
    Cell,
    Sticky,
    Popup,
    Dialog,
    Tab,
    Tabs,
    IndexBar,
    IndexAnchor,
    CellGroup,
    Loading,
} from "vant";
import { Image as VanImage } from "vant";
Component.registerHooks([
    "beforeRouteEnter",
    "beforeRouteLeave",
    "beforeRouteUpdate",
]);


Vue.config.productionTip = false;
Vue.use(DropdownItem)
    .use(Toast)
    .use(Cell)
    .use(Sticky)
    .use(Button)
    .use(Tabbar)
    .use(TabbarItem)
    .use(NavBar)
    .use(Swipe)
    .use(SwipeItem)
    .use(SwipeCell)
    .use(List)
    .use(PullRefresh)
    .use(VanImage)
    .use(CountDown)
    .use(Form)
    .use(Field)
    .use(Popup)
    .use(Dialog)
    .use(DropdownMenu)
    .use(Tab)
    .use(Tabs)
    .use(IndexBar)
    .use(IndexAnchor)
    .use(CellGroup)
    .use(Loading);

window.App = new Vue({
    router,
    render: (h) => h(App),
}).$mount("#app");
